// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"44f56014","239":"82918ce5","732":"dd34e722","762":"df892476","977":"091ce81f"}[chunkId] + ".chunk.js";
};